import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {ProofFinishedDetailPage} from './proof-finished-detail';

@NgModule({
  declarations: [
    ProofFinishedDetailPage,
  ],
  imports: [
    IonicPageModule.forChild(ProofFinishedDetailPage),
  ],
  exports: [
    ProofFinishedDetailPage
  ]
})
export class ProofFinishedDetailPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/proof-finished-detail/proof-finished-detail.module.ts